import { useMemo } from 'react';
import { useIoContext } from '~/contexts';
import { useHomePageRoutesByUrl } from '~/hooks/useHomePageRoutesByUrl';
import { filterHiddenNavLinks } from '~/utils/filterHiddenNavLinks';
export function useNativeFilteredNavLinks(links) {
    const { native } = useIoContext();
    const routesByUrl = useHomePageRoutesByUrl();
    const nativeHiddenRouteUrls = useMemo(()=>{
        if (!native.isNative) return new Set();
        return new Set(Object.values(routesByUrl).filter((config)=>!config.supportsMobileViewport).map((config)=>config.url));
    }, [
        native.isNative,
        routesByUrl
    ]);
    return filterHiddenNavLinks(links, nativeHiddenRouteUrls);
}
